const address = ({ address1, address2, county, postcode }) =>
  `
  ${address1 ? `${address1},` : ''}
  ${address2 ? `${address2},` : ''}
  ${county ? `${county},` : ''}
  ${postcode ? `${postcode}` : ''}
  `;

module.exports = address;
